import {
  FETCH_FEATURED_MATERIAL_REQUESTED,
  FETCH_FEATURED_MATERIAL_SUCCESSFUL,
  FETCH_FEATURED_MATERIAL_FAILED,
  FETCH_TOP_COURSES_REQUESTED,
  FETCH_TOP_COURSES_SUCCESSFUL,
  FETCH_TOP_COURSES_FAILED,
} from "./action-types"

const initialState = {
  topCourses: [],
  featuredCourse: {},
  isLoadingTopCourses: false,
  isLoadingFeaturedCourse: false,
  errors: {},
}

const landingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOP_COURSES_REQUESTED:
      return {
        ...state,
        isLoadingTopCourses: true,
        errors: {},
      }

    case FETCH_TOP_COURSES_SUCCESSFUL:
      return {
        ...state,
        isLoadingTopCourses: false,
        topCourses: action.payload.data,
      }

    case FETCH_TOP_COURSES_FAILED:
      return {
        ...state,
        isLoadingTopCourses: false,
        topCourses: [],
        // errors: action.error.response.data
      }

    case FETCH_FEATURED_MATERIAL_REQUESTED:
      return {
        ...state,
        isLoadingFeaturedCourse: true,
        errors: {},
      }

    case FETCH_FEATURED_MATERIAL_SUCCESSFUL:
      return {
        ...state,
        isLoadingFeaturedCourse: false,
        featuredCourse: action.payload.data,
      }

    case FETCH_FEATURED_MATERIAL_FAILED:
      return {
        ...state,
        isLoadingFeaturedCourse: false,
        // errors: action.error.response.data
      }

    default:
      return state
  }
}

export default landingReducer
